module.exports = __webpack_public_path__ + "img/1.481f6767.jpg";